import { cloneElement, ReactElement, useMemo, JSX } from 'react'

import { visuallyHidden } from '../mixins'

export interface VisuallyHiddenProps {
  children: ReactElement | JSX.Element
}

export const VisuallyHidden = ({ children }: VisuallyHiddenProps) => {
  const style = useMemo(
    () => ({ ...visuallyHidden(), ...children.props.style }),
    [children.props.style],
  )

  return cloneElement(children, { ...children.props, style })
}
